// extracted by mini-css-extract-plugin
module.exports = {"block_main_navigation":"block-main-navigation_block_main_navigation__Kiuni","dark":"block-main-navigation_dark__L1NWG"};